import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './FeatureSelection.css';

const FeatureSelection = () => {
  const navigate = useNavigate();
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeLoading, setIframeLoading] = useState(true);

  const features = [
    {
      id: 1,
      title: 'Translation Check',
      link: '/upload',
      status: 'live',
      note: 'Available now'
    },
    {
      id: 2,
      title: 'Prospectus Duplication Check',
      link: '/prospectus-check',
      // externalUrl: 'https://ipo-checker.tsingyuai.com',
      status: 'preview',
      note: 'Included during preview'
    },
    {
      id: 3,
      title: 'Promotional Language Check',
      link: '/regulations-check',
      status: 'preview',
      note: 'Included during preview'
    },
    {
      id: 4,
      title: 'Redaction Check',
      link: '',
      status: 'soon',
      note: 'Under development'
    },
    {
      id: 5,
      title: 'Validation Against Regulations',
      link: '',
      status: 'soon',
      note: 'Under development'
    },
    {
      id: 6,
      title: 'Validation of File Format',
      link: '',
      status: 'soon',
      note: 'Under development'
    }
  ];

  const sections = [
    {
      id: 'live',
      title: 'Available Now',
      subtitle: 'Production-ready capabilities',
      features: features.filter((feature) => feature.status === 'live')
    },
    {
      id: 'preview',
      title: 'In Preview',
      subtitle: 'Early access features open for evaluation',
      features: features.filter((feature) => feature.status === 'preview')
    },
    {
      id: 'soon',
      title: 'Coming Soon',
      subtitle: 'Planned capabilities on our roadmap',
      features: features.filter((feature) => feature.status === 'soon')
    }
  ];

  const statusMeta = {
    live: {
      label: 'Live',
      action: 'Launch'
    },
    preview: {
      label: 'Preview',
      action: 'Open Preview'
    },
    soon: {
      label: 'Soon',
      action: 'Planned'
    }
  };

  const moduleCount = {
    total: features.length,
    live: features.filter((feature) => feature.status === 'live').length,
    preview: features.filter((feature) => feature.status === 'preview').length,
    soon: features.filter((feature) => feature.status === 'soon').length
  };

  const handleFeatureClick = (feature) => {
    if (feature.externalUrl) {
      setIframeLoading(true);
      setIframeUrl(feature.externalUrl);
      return;
    }

    if (feature.link) {
      navigate(feature.link);
    }
  };

  const getActionLabel = (feature) => {
    if (feature.link || feature.externalUrl) {
      return statusMeta[feature.status].action;
    }
    if (feature.status === 'preview') {
      return 'Invitation Only';
    }
    return statusMeta[feature.status].action;
  };

  return (
    <>
      <div className="feature-selection-container">
        <header className="feature-page-header">
          <h1 className="feature-selection-title">Feature Workspace</h1>
          <p className="feature-selection-subtitle">
            Choose a capability lane and launch the checks aligned with your filing workflow.
          </p>
          <div className="feature-overview">
            <div className="overview-tile">
              <span>Total Modules</span>
              <strong>{moduleCount.total}</strong>
            </div>
            <div className="overview-tile">
              <span>Live</span>
              <strong>{moduleCount.live}</strong>
            </div>
            <div className="overview-tile">
              <span>Preview</span>
              <strong>{moduleCount.preview}</strong>
            </div>
            <div className="overview-tile">
              <span>Roadmap</span>
              <strong>{moduleCount.soon}</strong>
            </div>
          </div>
        </header>

        <div className="feature-sections">
          {sections.map((section) => (
            <section key={section.id} className="feature-section">
              <div className="feature-section-header">
                <div className="feature-section-heading">
                  <h2>{section.title}</h2>
                  <p>{section.subtitle}</p>
                </div>
                <span className="section-count">{section.features.length} Modules</span>
              </div>
              <div className="features-grid">
                {section.features.map((feature) => (
                  <button
                    key={feature.id}
                    type="button"
                    className={`feature-card card-${feature.status} ${!feature.link && !feature.externalUrl ? 'disabled' : ''}`}
                    disabled={!feature.link && !feature.externalUrl}
                    onClick={() => handleFeatureClick(feature)}
                  >
                    <span className={`feature-card-status status-${feature.status}`}>
                      {statusMeta[feature.status].label}
                    </span>
                    <div className="feature-content">
                      <h3>{feature.title}</h3>
                      <p>{feature.note}</p>
                    </div>
                    <span className="feature-card-cta">{getActionLabel(feature)}</span>
                  </button>
                ))}
              </div>
            </section>
          ))}
        </div>

        <button className="btn" onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>

      {iframeUrl && (
        <div className="feature-iframe-overlay">
          <button className="feature-iframe-back" onClick={() => setIframeUrl('')}>
            <FaArrowLeft /> Back
          </button>
          {iframeLoading && (
            <div className="iframe-loading-container">
              <div className="iframe-spinner"></div>
              <p>Loading Workspace...</p>
            </div>
          )}
          <iframe 
            src={iframeUrl} 
            title="Prospectus Duplication Check" 
            className={`feature-iframe ${iframeLoading ? 'iframe-hidden' : ''}`}
            onLoad={() => setIframeLoading(false)}
          />
        </div>
      )}
    </>
  );
};

export default FeatureSelection;
